import {
  SET_MENU_ITEM_DATA,
  TOGGLE_MODIFIERS_FORM,
  TOGGLE_MODIFIER_GROUPS_FORM,
  TOGGLE_MENU_ITEM_FORM,
  CREATE_MODIFIER,
  CREATE_MODIFIER_GROUP,
  UPDATE_MODIFIER_GROUP,
  UPDATE_MODIFIER,
  UPDATE_MENU_ITEM
} from './constants';

const initialState = {
  data: null,
  modifierOptionsFormView: false,
  modifiersFormView: false,
  menuItemFormView: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MENU_ITEM_DATA:
      return {
        ...state,
        data: action.payload,
      };
    case TOGGLE_MODIFIERS_FORM:
      return {
        ...state,
        modifiersFormView: !action.payload,
        modifierOptionsFormView: false,
        menuItemFormView: false,
      };
    case TOGGLE_MODIFIER_GROUPS_FORM:
      return {
        ...state,
        modifiersFormView: false,
        modifierOptionsFormView: !action.payload,
        menuItemFormView: false,
      };
    case TOGGLE_MENU_ITEM_FORM: {
      return {
        ...state,
        modifiersFormView: false,
        modifierOptionsFormView: false,
        menuItemFormView: !action.payload,
      }
    }
    case CREATE_MODIFIER:
      return {
        ...state,
        data: {
          ...state.data,
          modifierGroups: state.data.modifierGroups.map((option) => {
            if (option.id === action.payload.modifierGroupId) {
              option.modifiers.push(action.payload);
            }

            return option;
          }),
        }
      };
    case CREATE_MODIFIER_GROUP:
      return {
        ...state,
        data: {
          ...state.data,
          modifierGroups: state.data.modifierGroups.concat(action.payload),
        }
      };
    case UPDATE_MODIFIER_GROUP:
      return {
        ...state,
        data: {
          ...state.data,
          modifierGroups: state.data.modifierGroups.map((option) => {
            if (option.id === action.payload.id) {
              option.name = action.payload.name;
              option.description = action.payload.description;
              option.isEnabled = action.payload.isEnabled;
              option.isRequired = action.payload.isRequired;
            }

            return option;
          }),
        }
      };
    case UPDATE_MODIFIER:
      return {
        ...state,
        data: {
          ...state.data,
          modifierGroups: state.data.modifierGroups.map((option) => {
              option.modifiers.map(modifier => {
                if (modifier.id === action.payload.id) {
                  modifier.name = action.payload.name;
                  modifier.description = action.payload.description;
                  modifier.isEnabled = action.payload.isEnabled;
                  modifier.price = action.payload.isRequired;
                }

                return modifier;
              });

            return option;
          }),
        }
      };
    case UPDATE_MENU_ITEM:
      return {
        ...state,
        data: {
          ...state.data,
          name: action.payload.name,
          description: action.payload.description,
          isEnabled: action.payload.isEnabled,
        }
      };
    default:
      return state;
  }
};

export default reducer;